import React from 'react'
import HeroSection from '../../HeroSection'
import Portfolio from '../../Portfolio'
import ContactCTA from '../../ContactCTA'
import Footer from '../../Footer'

const Home = () => {
  return (
    <>
      <HeroSection />
      <Portfolio />
      <ContactCTA />
      <Footer />
    </>
  )
}

export default Home